export function loadReport() {
  return {
    type: 'LOAD_REPORT',
  };
}

export function loadReportCompletion(data, error) {
  return {
    type: 'LOAD_REPORT_COMPLETION',
    data,
    error,
  };
}

export function loadRefers() {
  return {
    type: 'LOAD_REFERS',
  };
}

export function loadRefersCompletion(data, error) {
  return {
    type: 'LOAD_REFERS_COMPLETION',
    data,
    error,
  };
}

export function loadRefersList(range) {
  return {
    type: 'LOAD_REFERS_LIST',
    range,
  };
}

export function loadRefersListCompletion(range, data, error) {
  return {
    type: 'LOAD_REFERS_LIST_COMPLETION',
    range,
    list: (data && data.listData) || [],
    error,
  };
}
